import { render, staticRenderFns } from "./CreateRelease.vue?vue&type=template&id=e68144e0"
import script from "./CreateRelease.vue?vue&type=script&lang=js"
export * from "./CreateRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports